import { requestOrThrow } from '../api-client'
import type { SubscriptionContract } from '../subscription-contract'
import type { SubscriptionEntry } from '../subscription-entry'
import type {
  SubscriptionRequest,
  SubscriptionRequestBase,
  SubscriptionRequestByToken,
} from '../subscription-request'

export function searchSubscriptionRequests(targetGroupMemberId?: number) {
  return requestOrThrow<SubscriptionRequestBase[]>('subscription_requests', {
    query: {
      status: 'waiting',
      // 一覧は単一 target スコープ。対象者(本人/メンバー)ごとに付与して取得する。
      ...(targetGroupMemberId != null ? { targetGroupMemberId } : {}),
    },
  })
}

export function getSubscriptionRequestDetail(id: number, targetGroupMemberId?: number) {
  return requestOrThrow<SubscriptionRequest>(`subscription_requests/${id}`, {
    // 詳細も単一 target スコープ。宛先(対象者)の pgm id。未指定=操作者自身。
    query: targetGroupMemberId != null ? { targetGroupMemberId } : {},
  })
}

// 契約URLのトークンで未所有/既所有を問わず表示専用に取得する(token_show・所有者不問)。
// 新規患者(glen未リンク)が対象者を選ぶ前でも申込内容を表示できる。
export function getSubscriptionRequestByToken(id: number, linkToken: string) {
  return requestOrThrow<SubscriptionRequestByToken>(`subscription_requests/${id}/token`, {
    headers: {
      'X-LINK-TOKEN': linkToken,
    },
  })
}

export function contractSubscriptionRequestByCreditCard(entry: SubscriptionEntry) {
  const targetGroupMemberId = entry.selectedTarget?.proxyGroupMemberId
  return requestOrThrow<SubscriptionContract>(
    `subscription_requests/${entry.subscriptionRequest!.id}/contract`,
    {
      method: 'POST',
      // 代理契約の宛先。未指定=操作者自身。宛先不一致は backend が 404 に縮退する。
      query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
    }
  )
}

export function linkSubscriptionRequest(
  subscriptionId: number,
  linkToken: string,
  targetGroupMemberId?: number
) {
  return requestOrThrow<SubscriptionRequest>(`subscription_requests/${subscriptionId}/link`, {
    method: 'POST',
    headers: {
      'X-LINK-TOKEN': linkToken,
    },
    query: {
      // 紐付け先(対象者)の pgm id。未指定=操作者自身。
      ...(targetGroupMemberId != null ? { targetGroupMemberId } : {}),
    },
  })
}
